import type * as React from 'react'

// React bubbles an event from a portal (a popover, a drawer) through every
// React ancestor, though the portal is not part of their DOM. A container's
// own activation (a row click, a swipe) must ignore those; outside-press
// logic must not, since overlays count their portals as inside.
export function isEventFromOwnDom(event: React.SyntheticEvent): boolean {
  return event.currentTarget.contains(event.target as Node)
}
